import React, { useState, useEffect } from "react";

const useLocalStorageBackedList = (key) => {
  const [values, setValues] = useState(
    JSON.parse(localStorage.getItem(key)) || []
  );

  const addValue = (value) => {
    if (values.includes(value)) {
      return;
    }
    const newValues = [...values, value];

    localStorage.setItem(key, JSON.stringify(newValues));

    setValues(newValues);
  };

  return {
    values,
    addValue,
  };
};
export default useLocalStorageBackedList;
